const BLOCK_TYPES = {
  EmptyBlock: { name: "EmptyBlock", id: "EmptyBlock" },
  Image: { name: "Image", id: "Image" },
  Text: { name: "Text", id: "Text" },
  TextInput: { name: "TextInput", id: "TextInput" },
  PhoneInput: { name: "PhoneInput", id: "PhoneInput" },
  Button: { name: "Button", id: "Button" },
};

export default BLOCK_TYPES;
